import _ from 'lodash'

export const defaultEventVideoTypes = {
	dv4_distraction: "snapshot_only",
	dv4_driver: "video_snapshot",
	dv4_drowsiness: "snapshot_only",
	dv4_ext_driver: "snapshot_only",
	dv4_fatal_gsensor: "video_snapshot",
	dv4_high_speed: "alert_only",
	dv4_phone_use: "snapshot_only",

	dv6_camera_block: "alert_only",
	dv6_distraction: "snapshot_only",
	dv6_driver: "video_snapshot",
	dv6_drowsiness: "snapshot_only",
	dv6_fatal_gsensor: "video_snapshot",
	dv6_following_distance: "snapshot_only",
	dv6_forward_collision: "snapshot_only",
	dv6_harsh_accel: "video_snapshot",
	dv6_harsh_braking: "video_snapshot",
	dv6_headway_monitoring: "snapshot_only",
	dv6_high_speed: "alert_only",
	dv6_lane_departure: "snapshot_only",
	dv6_phone_use: "snapshot_only",
	dv6_seatbelt: "snapshot_only",
	dv6_smoking: "snapshot_only",
	dv6_yawning: "snapshot_only",

	dv7_backup_warning: "snapshot_only",
	dv7_blind_spot_warning_standard: "snapshot_only",
	dv7_blind_spot_warning_urban: "snapshot_only",
	dv7_camera_block: "video_snapshot",
	dv7_distraction: "snapshot_only",
	dv7_driver: "video_snapshot",
	dv7_drowsiness: "snapshot_only",
	dv7_fatal_gsensor: "video_snapshot",
	dv7_following_distance: "snapshot_only",
	dv7_forward_collision: "snapshot_only",
	dv7_front_vehicle_start: "snapshot_only",
	dv7_gsensor_wakeup: "snapshot_only",
	dv7_harsh_accel: "video_snapshot",
	dv7_harsh_braking: "video_snapshot",
	dv7_headway_monitoring: "snapshot_only",
	dv7_high_speed: "alert_only",
	dv7_lane_departure: "snapshot_only",
	dv7_phone_use: "snapshot_only",
	dv7_seatbelt: "snapshot_only",
	dv7_smoking: "snapshot_only",
	dv7_speed_limit_violation_high: "snapshot_only",
	dv7_speed_limit_violation_low: "snapshot_only",
	dv7_speed_limit_violation_moderate: "snapshot_only",
	dv7_speed_limit_violation_severe: "snapshot_only",
	dv7_stop_sign_violation: "snapshot_only",
	dv7_traffic_light_violation: "snapshot_only",
	dv7_yawning: "snapshot_only"
}

const traverse = (res, o, parent = '') => {
	let i

	for (const k in o) {
		i = o[k]
		if (_.isArray(i)) {
			i.map((obj, index) => {
				if (parent) {
					if (obj.index) traverse(res, obj, `${parent}.${k}.${obj.index}`)
					else traverse(res, obj, `${parent}.${k}.${index}`)
				} else if (obj.index) traverse(res, obj, `${k}.${obj.index}`)
				else traverse(res, obj, `${k}.${index}`)
			})
		} else if (typeof i === 'object') {
			if (parent) traverse(res, i, `${parent}.${k}`)
			else traverse(res, i, k)
		} else {
			if (k == 'index') continue
			if (parent) {
				res[`${parent}.${k}`] = i
			} else {
				res[k] = i
			}
		}
	}
}

export const fillConfig = (config, profile) => {
	const res1 = {};
	const res2 = {}

	config.map((elem, index) => {
		const tmp = elem.split('=')
		const val = _.trim(tmp[1]).replace(/"/g, '')

		if (_.trim(tmp[0]) === '') {
			return false
		} if (val === '') {
			res1[_.trim(tmp[0])] = ''
		} else if (val === 'true') {
			res1[_.trim(tmp[0])] = true
		} else if (val === 'false') {
			res1[_.trim(tmp[0])] = false
		} else if (isNaN(val)) {
			res1[_.trim(tmp[0])] = val
		} else {
			res1[_.trim(tmp[0])] = val * 1
		}
	})

	profile = JSON.parse(profile)

	traverse(res2, profile)

	return { ...res1, ...res2 }
}
